import React, { useMemo } from "react";
import { Grid, TextField } from "@mui/material";
import { deriveDisplayedPathologyGroups } from "../saludClinicaV2Utils";

const GruposEnfermedadV2 = ({ diagnosticos = [] }) => {
  const groups = useMemo(
    () => deriveDisplayedPathologyGroups(diagnosticos),
    [diagnosticos]
  );

  return (
    <Grid container spacing={2}>
      {[0, 1].map((index) => (
        <Grid item xs={12} md={6} key={index}>
          <TextField
            fullWidth
            label={`Grupo / Tipo de Enfermedad ${index + 1}`}
            value={groups[index]?.descripcion || "N/A"}
            InputProps={{ readOnly: true }}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default GruposEnfermedadV2;
